import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost, doPostFile } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";


export const ReviewFile = createAsyncThunk(
    "reviewFile",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPostFile(urls?.fileReview, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const CompleteReview = createAsyncThunk(
    "completeReview",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await doPostFile(urls?.completeReview, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const ReviewFileSlice = createSlice({
    name: "reviewFile",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        reviewFileReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            }
        }
    },
    extraReducers: {
        [ReviewFile.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.data = payload;
            state.error = false;
        },
        [ReviewFile.pending]: (state) => {
            state.isLoading = true;
            state.data = false;
            state.error = null;
        },
        [ReviewFile.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

export const CompleteReviewSlice = createSlice({
    name: "completeReview",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        completeReviewReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            }
        }
    },
    extraReducers: {
        [CompleteReview.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.data = payload;
            state.error = false;
        },
        [CompleteReview.pending]: (state) => {
            state.isLoading = true;
            state.data = false;
            state.error = null;
        },
        [CompleteReview.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

export const { reviewFileReset } = ReviewFileSlice.actions;
export const { completeReviewReset } = CompleteReviewSlice.actions;